/**
 * How to run a bowling tournament
 */

export const runATournamentContent = `---
id: run-a-tournament
title: How to run a bowling tournament
description: Add teams, enter scores, run 8-player brackets, verify averages, then lock payouts and results.
category: tournament-management
type: tutorial
estimatedTime: 8 min read
path: /support/tutorials/run-a-tournament
lastUpdated: 2026-09-04
version: 3.2
tags:
  - bowling-tournament-software
  - scoring
  - averages
  - payouts
  - bowling-brackets
  - tournament-management
seo:
  title: How to run a bowling tournament | Bowling Tournament App
  description: Add teams, enter scores, run 8-player brackets, verify averages, then lock payouts and results.
  keywords:
    - bowling tournament software
    - bowling tournament scoring
    - tournament payouts
    - bowling brackets
---

# How to run a bowling tournament

Add teams on **Scoring**. If bowlers register themselves, turn on online signups under **Setup** and open **Signup Dashboard** to see who is on each squad. You cannot change which bowlers are on a team after you save it. Delete the team and create a new one.

Enter scratch scores on **Scoring**. Handicap is added from the bowler's average and the handicap settings. When every squad has bowlers and every bowler has a score, open **Averages**.

Names are one full name. There is no last-name field. Search matches any part of the name. **Verify** each average, or **Verify all** for every remaining one. You cannot verify team scores until every average is verified. **Unverify** a row if a number is wrong, unless that bowler is on a team whose scores are already verified.

Then verify team scores on **Scoring**.

Sell tickets and shuffle trees on **Brackets**. Leftover tickets refund after shuffle. 1st and 2nd show after Game 3. See [How to run bowling brackets](/support/tutorials/run-brackets).

On **Finance**, assign added money to events if you have any, then lock **Payouts**. You can change places and amounts. Totals must equal the prize fund. Pick the payout table at any time. You do not need it before you add teams.

Lock **Results** last. The PDF is then marked official.

If Verify or Lock is disabled, hover over the button. It will say what is missing.

---

- [How to create a bowling tournament](/support/tutorials/create-tournament)
- [How to run bowling brackets](/support/tutorials/run-brackets)
- [Getting started](/support/tutorials/getting-started)
`;

export default runATournamentContent;
